<template>
  <b-overlay :show="tableLoading" rounded="sm">
    <template>
      <b-modal v-model="showEditModal" size="lg" scrollable hide-footer class="pt-8" centered header-class="p-0"
        footer-class="d-flex justify-content-center border-0">
        <template #modal-title>
          <div class="title-block text-center p-2">
            {{ $translate('edit_duplicate_target') }}
          </div>
        </template>
        <!-- {{ selectedTargets[currentPage - 1][0] }} -->
        <div v-if="selectedTargets.length > 0 && selectedTargets[currentPage - 1][0]">
          <b-form class="form-sample" @submit.stop.prevent="saveChanges()">
            <b-row>
              <b-col cols="6 mt-2">
                <label class="mb-3">
                  <strong>{{ $translate('target_name') }}<span class="red">*</span></strong>
                </label>
                <b-form-input type="text" id="input-target_name" v-custom-validation="$textRequired()"
                  v-model="selectedTargets[currentPage - 1][0].name" required
                  :placeholder="$translate('enter_target_name')"></b-form-input>
              </b-col>

              <b-col cols="6 mt-2">
                <label class="mb-3">
                  <strong>{{ $translate('description') }}</strong>
                </label>
                <b-textarea id="input-description" v-model="selectedTargets[currentPage - 1][0].description"
                  :placeholder="$translate('description')"></b-textarea>
              </b-col>


              <b-col md="12" cols="12" class="mt-3  dd">

                <label for="input-type" class="mb-2"><strong>{{ $translate('activity_type') }}<span
                      class="red">*</span></strong></label>

                <multiselect id="input-order_type" :placeholder="$translate('select_activity_type')"
                  v-model="selectedTargets[currentPage - 1][0].type" :options="orderTypesArray" :searchable="true"
                  :limit="2" :multiple="true" :preserve-search="true" :selectLabel="selectLabel" label="name"
                  track-by="id" :close-on-select="true" @input="updateActivityTypes" />




              </b-col>

              <b-col md="6" cols="12" class="mt-3 text-start">
                <label for="input-outstanding_balance" class="mb-3"><strong>{{
                  $translate('target_no_of_activity') }}<span class="red">*</span></strong>
                </label>
                <b-form-checkbox class="mb-2" v-model="selectedTargets[currentPage - 1][0].target_type"
                  @change="onCountChecked" value="count" name="type-selection">
                  &nbsp; <strong>Count</strong>
                </b-form-checkbox>

                <b-input-group>
                  <b-form-input :disabled="selectedTargets[currentPage - 1][0].target_type != 'count'"
                    id="input-outstanding_balance" type="number"
                    v-model="selectedTargets[currentPage - 1][0].target_no_of_activity"></b-form-input>
                  <template #prepend>
                    <div class="customselect">
                      <select :disabled="selectedTargets[currentPage - 1][0].target_type != 'count'"
                        class="form-control" id="select-option-value"
                        v-model="selectedTargets[currentPage - 1][0].count_type" value-field="id" text-field="name"
                        block>
                        <option v-for="x in quantities_count" :key="'customselect:--' + x.id" :value="x.id">
                          {{ x.name }}
                        </option>
                      </select>
                    </div>
                  </template>
                </b-input-group>
              </b-col>
              <b-col md="6" cols="12" class="mt-3 text-start">
                <label for="input-outstanding_balance" class="mb-3"><strong>{{
                  $translate('target_total_value') }}<span class="red">*</span></strong>
                </label>
                <b-form-checkbox class="mb-2" v-model="selectedTargets[currentPage - 1][0].target_type"
                  @change="onValueChecked" value="value" name="type-selection">
                  <strong>&nbsp;Value</strong>
                </b-form-checkbox>
                <b-input-group>
                  <b-form-input :disabled="selectedTargets[currentPage - 1][0].target_type != 'value'"
                    id="input-outstanding_balance" type="number"
                    v-model="selectedTargets[currentPage - 1][0].target_total_value"></b-form-input>
                  <template #prepend>
                    <div class="customselect">
                      <select :disabled="selectedTargets[currentPage - 1][0].target_type != 'value'"
                        class="form-control" id="select-option-value"
                        v-model="selectedTargets[currentPage - 1][0].value_type" value-field="id" text-field="name"
                        block>
                        <option v-for="x in quantities_value" :key="'customselect:--' + x.id" :value="x.id">
                          {{ x.name }}
                        </option>
                      </select>
                    </div>
                  </template>
                </b-input-group>
              </b-col>
              <!-- <b-col cols="6 mt-2">
                <label class="mb-3"><strong>{{$translate('target_no_of_activity')}}</strong></label>
                <b-form-input type="number" id="input-target_no_of_activity" v-custom-validation="$textRequired()" v-model="model.target_no_of_activity"
                     :placeholder="$translate('enter_target_no_of_activity')" ></b-form-input>
            </b-col> -->

              <!-- <b-col cols="6 mt-2">
                <label class="mb-3"><strong>{{$translate('target_total_value')}}</strong></label>
                <b-form-input step="0.01" 
                min="0" type="number" id="input-target_total_value" v-custom-validation="$textRequired()" v-model="model.target_total_value"
                     :placeholder="$translate('enter_target_total_value')" ></b-form-input>
            </b-col> -->

              <b-col cols="12 mt-2" v-if="selectedTargets[currentPage - 1][0].id == 0">
                <b-col cols="12 mt-2">
                  <label class="mb-3"><strong>{{ $translate('target_period') }}</strong></label>

                </b-col>
                <b-col cols="12" v-for="(monthYear, index) in selectedTargets[currentPage - 1][0].month_year"
                  :key="index" class="mt-2">
                  <!-- Use d-flex to align input and button in one line -->
                  <div class="d-flex align-items-center">
                    <b-form-input type="month" :id="'input-month-year-' + index" v-custom-validation="$textRequired()"
                      v-model="selectedTargets[currentPage - 1][0].month_year[index]" required
                      :placeholder="$translate('enter_month_year')" class="flex-grow-1"></b-form-input>
                    <!-- Show "Close" button only for inputs after the first one -->
                    &nbsp;<b-button v-if="index > 0" variant="danger" class="ml-2" @click="removePeriod(index)"
                      style="white-space: nowrap;">X</b-button>
                  </div>
                </b-col>
                <b-col cols="12 mt-2">
                  <b-button variant="info" class="mt-3" @click="addPeriod">{{ $translate('add_period') }}</b-button>
                </b-col>

              </b-col>

              <b-col v-else cols="12 mt-2">
                <label class="mb-3">
                  <strong>{{ $translate('month_year') }}<span class="red">*</span></strong>
                </label>
                <b-form-input type="month" id="input-month-year" v-custom-validation="$textRequired()"
                  v-model="selectedTargets[currentPage - 1][0].month_year" required
                  :placeholder="$translate('enter_month_year')"></b-form-input>
              </b-col>


              <b-col md="6" cols="12" class="mt-3 dd">
                <label for="input-role" class="mb-2"><strong>{{ $translate('role') }}</strong></label>
                <multiselect id="input-role" :placeholder="$translate('select_role')"
                  v-model="selectedTargets[currentPage - 1][0].role" :options="roleArray" :searchable="true" :limit="2"
                  :multiple="true" :preserve-search="true" :selectLabel="selectLabel" label="name" track-by="id"
                  :close-on-select="true" @input="updateRoles" />
              </b-col>

              <b-col md="6" cols="12" class="mt-3 dd">
                <label for="input-officers" class="mb-2"><strong>{{ $translate('officers') }}</strong></label>
                <multiselect id="input-officers" :placeholder="$translate('select_officers')"
                  v-model="selectedTargets[currentPage - 1][0].officer" :options="officerArray" :searchable="true"
                  :limit="2" :multiple="true" :preserve-search="true" :selectLabel="selectLabel" label="name"
                  track-by="id" :close-on-select="true" @input="updateOfficers" />
              </b-col>

              <b-col md="6" cols="12" class="mt-3 dd">
                <label for="input-agents" class="mb-2"><strong>{{ $translate('agents') }}</strong></label>
                <multiselect id="input-agents" :placeholder="$translate('select_agents')"
                  v-model="selectedTargets[currentPage - 1][0].agent" :options="agentArray" :searchable="true"
                  :limit="2" :multiple="true" :preserve-search="true" :selectLabel="selectLabel" label="name"
                  track-by="id" :close-on-select="true" @input="updateAgents" />
              </b-col>

              <b-col md="6" cols="12" class="mt-3 dd">
                <label for="input-customer_segment" class="mb-2"><strong>{{ $translate('customer_segment')
                    }}</strong></label>
                <multiselect id="input-customer_segment" :placeholder="$translate('select_customer_segment')"
                  v-model="selectedTargets[currentPage - 1][0].customer_segment" :options="segmentArray"
                  :searchable="true" :limit="2" :multiple="true" :preserve-search="true" :selectLabel="selectLabel"
                  label="name" track-by="id" :close-on-select="true" @input="updateCustomerSegments" />
              </b-col>

              <b-col md="6" cols="12" class="mt-3 dd">
                <label for="input-interaction_type" class="mb-2"><strong>{{ $translate('interaction_type')
                    }}</strong></label>
                <multiselect id="input-interaction_type" :placeholder="$translate('select_interaction_type')"
                  v-model="selectedTargets[currentPage - 1][0].interaction_type" :options="interaction_typeArray"
                  :searchable="true" :limit="2" :multiple="true" :preserve-search="true" :selectLabel="selectLabel"
                  label="name" track-by="id" :close-on-select="true" @input="updateInteractionTypes" />
              </b-col>

              <b-col md="6" cols="12" class="mt-3 dd">
                <label for="input-customer_group" class="mb-2"><strong>{{ $translate('customer_group')
                    }}</strong></label>
                <multiselect id="input-customer_group" :placeholder="$translate('select_customer_group')"
                  v-model="selectedTargets[currentPage - 1][0].customer_group" :options="customerGroupArray"
                  :searchable="true" :limit="2" :multiple="true" :preserve-search="true" :selectLabel="selectLabel"
                  label="name" track-by="id" :close-on-select="true" @input="updateCustomerGroups" />
              </b-col>


              <b-col cols="12" class="mt-3 d-flex gap-2 justify-content-center">
                <b-button id="submit-btn" variant="info" type="submit" :disabled="submitting">
                  {{ $translate('duplicate') }}
                </b-button>



                <b-button id="cancel-btn" variant="info" :disabled="submitting" @click="cancel">
                  {{ $cancelLabel() }}
                </b-button>
              </b-col>
            </b-row>
          </b-form>

          <!-- Pagination Controls -->
          <div class="pagination-controls">
            <button @click="prevPage" :disabled="currentPage === 1" aria-label="Previous">
              <span>&laquo; Previous</span>
            </button>

            <span>Page {{ currentPage }} of {{ totalPages }}</span>

            <button @click="nextPage" :disabled="currentPage >= totalPages" aria-label="Next">
              <span>Next &raquo;</span>
            </button>
          </div>
        </div>

        <!-- Display a loading message if no data is available -->
        <div v-else>
          <p>{{ $translate('loading_targets') }}</p>
        </div>
      </b-modal>
    </template>
    <b-modal v-model="isModalVisible" id="message-modal" hide-footer class="pt-8" centered header-class="p-0"
      footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
      <template #modal-title>
        <div class="title-block text-center p-2">
          {{ $translate('activity_types') }}
        </div>
      </template>

      <div>
        <b-badge v-for="(activity_type, index) in activityTypes" :key="index" variant="success" class="role-badge m-1">
          {{ activity_type.activity_type.name }}
        </b-badge>
      </div>

    </b-modal>
    <b-modal v-model="isExtendModalVisible" id="message-modal" hide-footer class="pt-8" centered header-class="p-0"
    footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
    
    <!-- Modal Title -->
    <template #modal-title>
      <div class="title-block text-center p-2">
        {{ $translate('extend_target') }}
      </div>
    </template>

    <!-- Form with radio buttons in one line -->
    <div class="p-3">
      <b-form-group >
        <label><b> {{$translate('extend_for')}}</b></label>
        <div class="d-flex align-items-center">
          <!-- Radio for Month -->
          <b-form-radio v-model="extendModel.selectedOption" name="extendOption" value="month" class="m-3 mt-3">
            {{$translate('extend_for_months')}}
          </b-form-radio>

          <!-- Radio for Year -->
          <b-form-radio v-model="extendModel.selectedOption" name="extendOption" value="year"  class="m-3 mt-3">
            {{$translate('extend_for_year')}}
          </b-form-radio>
        </div>

        <!-- Show number of months input if 'Extend for Month' is selected -->
        <b-form-group v-if="extendModel.selectedOption === 'month'" class="mt-3">
          <b-form-input v-model="extendModel.numMonths" type="number" placeholder="Enter number of months"></b-form-input>
        </b-form-group>
      </b-form-group>
      <b-col cols="12" class="mt-3 d-flex gap-2 justify-content-center">
        <b-button id="submit-btn" @click="extend_record()" variant="info" type="button" :disabled="submitting">
          {{ $translate('extend') }}
        </b-button>



        <b-button id="cancel-btn" variant="info" :disabled="submitting" @click="cancel">
          {{ $cancelLabel() }}
        </b-button>
      </b-col>
    </div>
  </b-modal>
    <b-modal v-model="isViewVisible" id="target-modal" hide-footer class="pt-8" centered header-class="p-0"
      footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
      <template #modal-title>
        <div class="title-block text-center p-2">
          {{ modal_title }}
        </div>
      </template>

      <div>
        <ViewTargetsModal :id="currentTargetId" @closeModal="CloseTheModal" @buttonClicked="handleButtonClick" />
      </div>

    </b-modal>
    <b-card class="inner-block health-listing">
      <b-card-header>
        <import-form :subject="$translate('targets')" v-model="importModal" @cancel="hideModal()"
          :fields="inventoryFields" :upload-record="uploadInventoryRecord" :istarget="isTarget"
          settings-key-name="TargetsUploadKey"></import-form>
        <b-row class="mt-2">

          <!-- <b-col cols="2" md="1" lg="1"
                        class="d-flex align-items-center justify-content-center"><strong>health</strong></b-col>
                    <b-col cols="10" md="11" lg="11" class="d-flex"> -->
          <b-col cols="12"
            class="d-flex gap-1 gap-md-2 ps-3 mt-1 mt-md-0 align-self-baseline align-self-md-center master-item-button">
            <b-input type="text" :placeholder="$translate('search_filter')" v-model="query"></b-input>


            <b-button id="add-checkoff-btn" variant="blue-icon" v-b-tooltip.hover :title="$addLabel()"
              v-if="hasPermissionCreate" @click="addBudget">
              <img src="@/assets/images/icon/gradient-add.svg" />
            </b-button>

            <b-button id="import-checkoff-item-btn" variant="blue-icon" v-b-tooltip.hover :title="$translate('import')"
              @click="openModel()" v-if="hasPermissionCreate">
              <img src="@/assets/images/icon/import.svg" />
            </b-button>
            <b-button id="export-checkoff-item-btn" variant="blue-icon" v-b-tooltip.hover :title="$translate('export')"
              @click="export_roster()" v-if="hasPermissionCreate">
              <img src="@/assets/images/icon/export.svg" />
            </b-button>
            <b-button id="reset-filter-btn" variant="blue-icon" @click="resetFilters" v-b-tooltip.hover
              :title="$translate('reset_filters')">
              <b-icon icon="arrow-repeat" class="fs-2" variant="dark" style=" font-size: 1.5rem"></b-icon>
            </b-button>
            <b-button variant="blue-icon" id="toggle-filter-btn" v-if="hasPermissionView" class="me-2"
              @click="toggle_filters = !toggle_filters" v-b-tooltip.hover :title="$translate('filter')">

              <img src="@/assets/images/icon/filter-f.svg" />
            </b-button>
            <b-button variant="blue-icon" id="calender-view-btn" v-if="hasPermissionView" class="me-2" v-b-tooltip.hover
              :title="$translate('calender_view')" @click="navigateToCalender">

              <img src="@/assets/images/icon/scheduling-w.svg" />
            </b-button>
            <target-actions class="activity-btn" :dropdown-actions="otherActions"
              :dropdown-title="$translate('bulk_actions')" control-class="float-right" control-size="lg" />
          </b-col>
        </b-row>
        <targets-filters v-show="toggle_filters" v-model="filters" />
      </b-card-header>
      <b-card-body class="button-off">
        <b-col class="page-block">
          <strong>
            {{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{ pageCount }} {{
              $translate('total') }}:
            {{ pagination.total }}
          </strong>
        </b-col>
        <b-col class="overflow-auto w-100 mt-4">
          <b-table show-empty :empty-text="$translate('records_not_found')" small selectable
            @row-selected="onRowSelected" ref="selectableTable" id="order-table" responsive :items="targets"
            :fields="fields">
            <template #head(check)>
              <input id="select-order-check-box-all" type="checkbox" class="form-check-input"
                :checked="targets.length === selectedOrders.length && targets.length > 0" @change="toggleAllRow()" />
            </template>

            <template #cell(check)="{ rowSelected, index }">
              <input :id="'select-order-check-box-' + index" type="checkbox" class="form-check-input"
                :checked="rowSelected" @change="toggleRow(index, rowSelected)" />
            </template>

            <template>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <!-- <strong>{{ $translate('loading') }}</strong> -->
              </div>
            </template>
            <!-- <template #cell(id)="row">
              <b-button :id="'view-roster-btn-' + row.item.id" @click="open_extend_modal(row.item)"
                class="mr-2 test-view-document-type-btn" variant="pink-button">
                <i class="fas fa-expand-alt" style="color: #ffffff;"></i>
              </b-button>

            </template> -->
            <template #cell(name)="row">
              <!-- <b-button :id="'view-roster-btn-'+row.item.id" @click="view(row.item.id)"  class="mr-2 test-view-document-type-btn" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button> -->
              <span @click="view(row.item.id)">
                <a href="javascript:void(0);">{{ row.item.name }}</a>
              </span>
            </template>
            <template #cell(month_year)="row">
              <div class="role-badge-container">
                {{ formatMonthYear(row.item.month_year) }}
              </div>
            </template>
            <template #cell(target)="row">


              <div class="role-badge-container">
                <span v-if="row.item.target_type === 'count'">
                  <span>
                    <!-- Use the count_type to determine the sign -->
                    {{ row.item.count_type === 1 ? '=' : (row.item.count_type === 2 ? '>' : (row.item.count_type === 3 ?
                      '<' : '')) }} </span>
                      {{ row.item.target_no_of_activity }}

                  </span>
                  <span v-if="row.item.target_type === 'value'">
                    <span>
                      <!-- Use the count_type to determine the sign -->
                      {{ row.item.value_type === 1 ? '=' : (row.item.value_type === 2 ? '>' : (row.item.value_type === 3
                        ? '<' : '')) }} </span>
                        {{ row.item.target_total_value }}
                    </span>
              </div>
            </template>

            <template #cell(roles)="row">
              <div class="role-badge-container">
                <b-badge v-for="(role, index) in row.item.roles" :key="index" variant="success" class="role-badge">
                  {{ role?.role?.name }}
                </b-badge>
              </div>
            </template>
            <template #cell(activity_types)="row">
              <div class="role-badge-container">
                <b-badge v-for="(activity_type, index) in row.item.activity_types.slice(0, 2)" :key="index"
                  variant="success" class="role-badge">
                  {{ activity_type?.activity_type?.name }}
                </b-badge>
                <!-- Show additional badges count if there are more than two -->
                <span v-if="row.item.activity_types.length > 2" @click="showModal(row.item.activity_types)"
                  class="badge-more">
                  +{{ row.item.activity_types.length - 2 }}...
                </span>
              </div>
              <!-- <b-modal
                            v-model="isModalVisible"
                            title="All Activity Types"
                            @hide="resetModal"
                          >
                            <div>
                              <b-badge
                                v-for="(activity_type, index) in  row.item.activity_types"
                                :key="index"
                                variant="success"
                                class="role-badge"
                              >
                                {{ activity_type.activity_type.name }}
                              </b-badge>
                            </div>
                          </b-modal> -->

            </template>
            <template #cell(officers)="row">
              <div class="role-badge-container">
                <b-badge v-for="(officer, index) in row.item.officers" :key="index" variant="success"
                  class="role-badge">
                  {{ officer?.officer?.first_name }} {{ officer?.officer?.last_name }}
                </b-badge>
              </div>
            </template>
            <template #cell(agents)="row">
              <div class="role-badge-container">
                <b-badge v-for="(agent, index) in row.item.agents" :key="index" variant="success" class="role-badge">
                  {{ agent?.agent?.first_name }} {{ agent?.agent?.last_name }}
                </b-badge>
              </div>
            </template>
            <template #cell(customer_segments)="row">
              <div class="role-badge-container">
                <b-badge v-for="(customer_segment, index) in row.item.customer_segments" :key="index" variant="success"
                  class="role-badge">
                  {{ customer_segment?.customer_segment?.name }}
                </b-badge>
              </div>
            </template>
            <template #cell(customer_group)="row">
              <div class="role-badge-container">
                <b-badge v-for="(customer_group, index) in row.item.customer_groups" :key="index" variant="success"
                  class="role-badge">
                  {{ customer_group?.customer_group?.name }}
                </b-badge>
              </div>
            </template>
            <template #cell(interaction_types)="row">
              <div class="role-badge-container">
                <b-badge v-for="(interaction_type, index) in row.item.interaction_types" :key="index" variant="success"
                  class="role-badge">
                  {{ interaction_type?.interaction_type?.name }}
                </b-badge>
              </div>
            </template>

          </b-table>
        </b-col>
        <b-row>
          <b-col>
            <b-pagination class="justify-content-center mt-4" v-model="pagination.page" :total-rows="pagination.total"
              :per-page="pagination.pageSize" aria-controls="customerTable" :prev-text="$translate('previous')"
              :next-text="$translate('next')" pills align="right"></b-pagination>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>
<script>
import _ from 'lodash'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import TargetsFilters from './TargetsFilters.vue'
import importMixins from "@/mixins/importMixins";
import ImportForm from "@/components/ImportForm.vue";
import TargetActions from "@/components/TargetActions.vue";
import dropdownIcon2 from "@/assets/images/icon/i-2.svg";
import dropdownIcon7 from "@/assets/images/icon/i-7.svg";
import ViewTargetsModal from './ViewTargetsModal.vue';
import Multiselect from 'vue-multiselect'

const inventoryFields = [
  { name: "name", label: "name", required: true, type: "text" },
  { name: "description", label: "description", required: true, type: "text" },
  { name: "month_year", label: "month_year", required: true, type: "text" },

  {
    name: "activity_type",
    label: "activity_type",
    required: true,
    type: "text",
  },
  { name: "target_type", label: "target_type", required: true, type: "text" },

  {
    name: "target_no_of_activity",
    label: "target_no_of_activity",
    required: false,
    type: "number",
  },
  {
    name: "target_total_value",
    label: "target_total_value",
    required: false,
    type: "number",
  },
  {
    name: "role",
    label: "role",
    required: false,
    type: "text",
  },
  {
    name: "officer",
    label: "officer",
    required: false,
    type: "text",
  },
  {
    name: "agent",
    label: "agent",
    required: false,
    type: "text",
  },
  {
    name: "customer_segment",
    label: "customer_segment",
    required: false,
    type: "text",
  },
  {
    name: "customer_group",
    label: "customer_group",
    required: false,
    type: "text",
  },
  {
    name: "interaction_type",
    label: "interaction_type",
    required: false,
    type: "text",
  },




];
export default {
  name: 'health-table',
  mixins: [popupMixins, permissionsMixins, importMixins],
  components: {
    TargetsFilters,
    ImportForm,
    TargetActions,
    ViewTargetsModal,
    Multiselect

  },
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      selectedOrders: [],
      query: '',
      tableLoading: false,
      toggle_filters: false,
      filters: {
      },
      importModal: false,
      inventoryFields,
      isTarget: 'yes',
      activityTypes: [],
      isModalVisible: false,
      isViewVisible: false,
      currentTargetId: null,

      showEditModal: false,
      currentPage: 1,
      selectedTargets: [],
      submitting: false,

      orderTypesArray: [],
      roleArray: [],
      officerArray: [],
      agentArray: [],
      segmentArray: [],
      interaction_typeArray: [],
      customerGroupArray: [],
      quantities_count: [
        { id: 1, name: '=' },
        { id: 2, name: '>' },
        { id: 3, name: '<' },
      ],
      quantities_value: [
        { id: 1, name: '=' },
        { id: 2, name: '>' },
        { id: 3, name: '<' },
      ],
      enableCount: false,
      enableValue: false,
      isExtendModalVisible: false,
      
      extendModel:{
        selectedOption: null, // store the selected radio option (month or year)
        numMonths: null, // track the number of months if 'Extend for Month' is selected
        record_to_extend : null,

      }
    
    }
  },
  computed: {
    modal_title() {
      return this.currentTargetId ? this.$translate('targets') : this.$translate('create_targets');
    },
    fields() {
      return [
        {
          key: 'check',
          label: '', // Set the label to an empty string to hide the heading
        },
       // { key: 'id', label: this.$translate('actions') },
        { key: 'name', label: this.$translate('name') },
        { key: 'target_type', label: this.$translate('target_type') },
        { key: 'month_year', label: this.$translate('month_year') },

        { key: 'target', label: this.$translate('target') },
        { key: 'actuals', label: this.$translate('actual') },
        // { key: 'target_total_value', label: this.$translate('target_total_value') },

        { key: 'activity_types', label: this.$translate('activity_types') },
        { key: 'roles', label: this.$translate('roles') },
        { key: 'officers', label: this.$translate('officers') },
        { key: 'agents', label: this.$translate('agents') },
        { key: 'customer_segments', label: this.$translate('customer_segments') },
        { key: 'customer_group', label: this.$translate('customer_groups') },
        { key: 'interaction_types', label: this.$translate('interaction_types') },
        // { key: 'end_time', label: this.$translate('end_time') },
        // { key: 'shift', label: this.$translate('shift') },

      ]
    },
    pageCount() {
      return Math.ceil(this.pagination.total / this.pagination.pageSize)
    },
    targets() {
      const targets = this.$store.state.targets.items

      return targets
    },
    pagination() {
      return this.$store.state.targets.pagination || { page: 1 }
    },
    otherActions() {
      const actions = [];

      actions.push(
        {
          action: () => this.duplicate_target(),
          icon: dropdownIcon2,
          text: this.$translate("duplicate_target"),

        },
        {
          action: () => this.view_analytics(),
          icon: dropdownIcon2,
          text: this.$translate("view_analytics"),

        },
        // {
        //   action: () => this.generate_report(),
        //   icon: dropdownIcon2,
        //   text: this.$translate("generate_report"),

        // },
        {
          action: () => this.bulk_delete(),
          icon: dropdownIcon7,
          text: this.$translate("delete"),

        },

      );



      return actions;
    },
    totalPages() {
      return Math.ceil(this.selectedTargets.length / 1); // Change '1' to your desired per-page value
    },
    selectLabel() {
      return this.$translate('click_to_select')
    },
    deselectLabel() {
      return this.$translate('click_to_remove')
    },
    selectedLabel() {
      return this.$translate('selected')
    },
    officers() {
      return (this.$store.state.orders.drivers || []).map((x) => ({
        id: x.id,
        name: `${x.first_name} ${x.last_name}`.trim(),
      }));
    },
    roles() {
      return this.$store.state.roles.items;
    },
    categories() {
      return this.$store.state.requestCategory.categories;
    },

    interactionTypes() {
      return this.$store.state.interactionType.interaction_types;
    },
    customerAgents() {
      return this.$store.state.customerAgents.customer_agents.map(user => {
        return {
          ...user,
          name: `${user.first_name} ${user.last_name}`
        };
      });;
    },
    customerSegments() {
      return this.$store.state.customerSegments.customer_segments
    },
    customerGroups() {
      return this.$store.state.customerGroups.customer_groups
    },


  },

  watch: {
    selectedTargets(newTargets) {
      if (newTargets.length === 0) {
        this.currentPage = 1;
      } else if (this.currentPage > Math.ceil(newTargets.length / 1)) {
        this.currentPage = Math.ceil(newTargets.length / 1);
      }
    },
    targets: {
      handler: function () {
        this.tableLoading = false
      },
      deep: true,
    },
    'pagination.page': function (newPage) {
      this.changePage(newPage)
    },
    query: _.debounce(function (query) {
      this.$router.push({ query: { query } })
      this.doSearch()
    }, 200),
    filters: {
      handler: function () {

        this.doSearch(true)
      },
      deep: true,
    },

  },

  // async created() {
  //   await Promise.all([
  //     this.$store.dispatch("orderType/fetchAll"),
  //     this.$store.dispatch("roles/fetchAll"),
  //     this.$store.dispatch("orders/fetchDriversNew"),
  //     this.$store.dispatch("customerAgents/fetchAll"),
  //     this.$store.dispatch("interactionType/fetchAll"),
  //     this.$store.dispatch('customerSegments/fetchAll'),
  //     this.$store.dispatch('customerGroups/fetchAll')
  //   ]);
  // },
  mounted() {

    this.orderTypesArray = this.$store.getters["orderType/activityTypesByPermission"];
    this.roleArray = this.roles;
    this.officerArray = this.officers;
    this.agentArray = this.customerAgents;
    this.segmentArray = this.customerSegments;
    this.interaction_typeArray = this.interactionTypes;
    this.customerGroupArray = this.customerGroups;
    if (this.$route.query.query) this.query = this.$route.query.query
    this.doSearch()
    console.log('stored filter is -------',)
    if (this.$store.state.targets.filter && this.$store.state.targets.filter != null) {
      console.log('This is filter -----', this.$store.state.targets.filter.officer);

      // Check if the officer filter is not empty
      if (this.$store.state.targets.filter.officer !== "") {
        // Split the comma-separated 'value' string into an array of IDs
        let ids = value.split(',').map(id => id.trim());

        // Filter officers based on matching IDs
        let filtered_officer = this.$store.state.targets.filter.officer.filter(x => ids.includes(String(x.id)));

        // Set the filtered officer list in the filters object
        this.$set(this.filters, 'officer', filtered_officer || []);
      }
    }

  },

  methods: {
    async bulk_delete() {
      try {
        const title = this.$translate("delete_target_title");
        const message = this.$translate(`delete_target_note`);

        const result = await this.confirmMessage(title, message);
        console.log("result", result);
        if (!result) return false; //throw new Error("");

        this.tableLoading = true;
        await this.$store.dispatch("targets/bulkDelete", {
          targets: this.selectedOrders,
        });

        this.doToast(
          this.$translate("success"),
          this.$translate("bulk_target_delete"),
          "success"
        );

        await this.doSearch();
      } catch (err) {
        console.error(err);
        this.doToast(
          this.$translate("error"),
          this.$translate("bulk_target_delete_error"),
          "danger"
        );
      } finally {
        this.clearSelected();
        this.doSearch(true);
        this.tableLoading = false;
      }
    },
    generate_report() {

    },
    view_analytics() {
      this.$router.push({ name: 'ViewAnalytics' });
    },
    navigateToCalender() {
      this.$router.push({ name: 'viewTargetCalender' });
    },
    async duplicate_target() {
      try {
        const targetIds = this.selectedOrders.map(order => order.id);
        console.log('Target IDs:', targetIds);

        // Filter and map the targets to the required structure
        const filteredTargets = this.targets.filter(target => targetIds.includes(target.id));

        if (filteredTargets.length === 0) {
          throw new Error('No targets found for the selected orders.');
        }

        // Create a structure for pagination
        const targetsPerPage = 1; // Adjust this number based on your pagination needs
        this.selectedTargets = [];

        for (let i = 0; i < filteredTargets.length; i += targetsPerPage) {

          console.log('this is data=============', filteredTargets);
          const pageTargets = filteredTargets.slice(i, i + targetsPerPage).map(target => ({
            id: target.id,
            month_year: target.month_year || [],
            target_no_of_activity: target.target_no_of_activity || 0,
            target_total_value: target.target_total_value || 0,
            name: target.name || '',
            count_type: target.count_type || '',
            value_type: target.value_type || '',
            target_type: target.target_type || '',
            description: target.description || '',
            activity_types: target.activity_types.map(activity => activity.activity_type_id) || [],
            roles: target.roles.map(role => role.role_id) || [],
            officers: target.officers.map(officer => officer.officer_id) || [],
            agents: target.agents.map(agent => agent.agent_id) || [],
            customer_segments: target.customer_segments.map(segment => segment.segment_id) || [],
            interaction_types: target.interaction_types.map(interaction_type => interaction_type.interaction_type_id) || [],
            interaction_type_id: target.interaction_type_id || '',
            customer_groups: target.customer_groups.map(group => group.customer_group_id) || [],
          }));

          this.selectedTargets.push(pageTargets); // Add the page of targets
        }

        this.currentPage = 1; // Reset to the first page

        // Show the modal
        this.showEditModal = true;

        // Ensure the DOM updates after setting currentPage
        await this.$nextTick();
        console.log('currentPage is =====', this.currentPage);
        if (this.selectedTargets[this.currentPage - 1][0].id !== null && this.selectedTargets[this.currentPage - 1][0].id != 0) {
          this.tableLoading = true;
          // await this.$store.dispatch('targets/fetchById',this.selectedTargets[ this.currentPage - 1][0].id)
          // Function to set selected values from Vuex store based on IDs in selectedTargets
          const setSelectedValues = (sourceArray, targetKey, idArray, arrayName) => {
            let selectedItems = [];

            idArray.forEach(id => {
              const filteredItems = sourceArray.filter(item => item.id === id);
              selectedItems = selectedItems.concat(filteredItems);
            });

            this.$set(this.selectedTargets[this.currentPage - 1][0], targetKey, selectedItems.length ? Array.from(new Set(selectedItems)) : []);
          };

          // Setting selected activity types
          const activityTypeIds = this.selectedTargets[this.currentPage - 1][0].activity_types;
          setSelectedValues(this.orderTypesArray, 'type', activityTypeIds, 'activity_types');

          // Setting selected agents
          const agentIds = this.selectedTargets[this.currentPage - 1][0].agents;

          setSelectedValues(this.agentArray, 'agent', agentIds, 'agents');

          // Setting selected customer segments
          const segmentIds = this.selectedTargets[this.currentPage - 1][0].customer_segments;
          setSelectedValues(this.segmentArray, 'customer_segment', segmentIds, 'customer_segments');

          // Setting selected officers
          const officerIds = this.selectedTargets[this.currentPage - 1][0].officers;
          console.log('officerIds======', this.officerArray);
          setSelectedValues(this.officerArray, 'officer', officerIds, 'officers');

          // Setting selected roles
          const roleIds = this.selectedTargets[this.currentPage - 1][0].roles;
          setSelectedValues(this.roleArray, 'role', roleIds, 'roles');

          // Setting selected interaction types
          const interactionTypeIds = this.selectedTargets[this.currentPage - 1][0].interaction_types;
          setSelectedValues(this.interaction_typeArray, 'interaction_type', interactionTypeIds, 'interaction_types');

          // Setting selected customer groups
          const customerGroupIds = this.selectedTargets[this.currentPage - 1][0].customer_groups;
          setSelectedValues(this.customerGroupArray, 'customer_group', customerGroupIds, 'customer_groups');

        }

      } catch (err) {
        console.error(err);
        this.doToast(
          this.$translate("error"),
          this.$translate("bulk_target_duplicate_error"),
          "danger"
        );
      } finally {
        this.clearSelected();
        this.doSearch(true);
        this.tableLoading = false;
      }
    },


    clearSelected() {
      this.$refs.selectableTable && this.$refs.selectableTable.clearSelected();
    },
    onRowSelected(items) {
      this.selectedOrders = items;
    },
    toggleRow(index, rowSelected) {
      // Rows are indexed from 0, so the third row is index 2
      if (rowSelected) this.$refs.selectableTable.unselectRow(index);
      else this.$refs.selectableTable.selectRow(index);
    },

    toggleAllRow() {
      if (this.targets.length === this.selectedOrders.length)
        this.$refs.selectableTable.clearSelected();
      else this.$refs.selectableTable.selectAllRows();
    },

    changePage(page) {
      this.$router.push({ query: { page } })
      this.doSearch()
    },
    resetFilters() {
      this.setDefaultDateRange();
      this.doSearch()
    },
    async doSearch() {
      let type = "";
      if (this.filters.type && this.filters.type.length > 0 && Array.isArray(this.filters.type)) {
        type = this.filters.type.map((i) => i.id).join(",");
      }

      let role = "";
      if (this.filters.role && this.filters.role.length > 0 && Array.isArray(this.filters.role)) {
        role = this.filters.role.map((i) => i.id).join(",");
      }

      let officer = "";
      if (this.filters.officer && this.filters.officer.length > 0 && Array.isArray(this.filters.officer)) {
        officer = this.filters.officer.map((i) => i.id).join(",");
      }

      let agent = "";
      if (this.filters.agent && this.filters.agent.length > 0 && Array.isArray(this.filters.agent)) {
        agent = this.filters.agent.map((i) => i.id).join(",");
      }
      let customer_segment = "";
      if (this.filters.customer_segment && this.filters.customer_segment.length > 0 && Array.isArray(this.filters.customer_segment)) {
        customer_segment = this.filters.customer_segment.map((i) => i.id).join(",");
      }

      let interaction_type = "";
      if (this.filters.interaction_type && this.filters.interaction_type.length > 0 && Array.isArray(this.filters.interaction_type)) {
        interaction_type = this.filters.interaction_type.map((i) => i.id).join(",");
      }

      let customer_group = "";
      if (this.filters.customer_group && this.filters.customer_group.length > 0 && Array.isArray(this.filters.customer_group)) {
        customer_group = this.filters.customer_group.map((i) => i.id).join(",");
      }


      try {
        this.$store.commit('targets/updateFilter', {
          query: this.query,
          filters: { ...this.filters, type: type, role: role, officer: officer, agent: agent, customer_segment: customer_segment, interaction_type: interaction_type, customer_group: customer_group }
        });
        this.tableLoading = true
        const {
          pagination: { page },
          query,
          filters
        } = this
        await this.$store.dispatch('targets/fetch', {
          query,
          page,
          filters: { ...filters, type: type, role: role, officer: officer, agent: agent, customer_segment: customer_segment, interaction_type: interaction_type, customer_group: customer_group }
        })
      } catch (error) {
        console.error('loading error', error)
      }
    },
    view(index) {
      // const path = `${this.$route.path}/${index}`
      // console.log('path---',path);
      // this.$router.push({ path })
      this.currentTargetId = index;
      this.isViewVisible = true;
    },

    truncate(text, length) {
      return _.truncate(text, { length: length })
    },
    handleButtonClick() {
      this.doSearch();
      this.isViewVisible = false;

    },
    CloseTheModal() {
      this.currentTargetId = 0;
      this.isViewVisible = false;
    },
    addBudget() {
      this.currentTargetId = 0;
      this.isViewVisible = true;
      // const id = 0
      // this.$router.push({ params: { id }, name: 'viewTarget' })
    },
    async uploadInventoryRecord(
      dataRecord,
      statusRecord,
      // { check, message, field },
      statuses,
      // setLoading
    ) {


      try {
        let {
          month_year,
          activity_type,
          role,
          officer,
          agent,
          customer_segment,
          customer_group,
          interaction_type,
          target_total_value,
          target_no_of_activity,
          name,
          target_type,
          description

        } = dataRecord;


        month_year = month_year.trim();
        activity_type = activity_type.trim();
        role = role.trim();
        officer = officer.trim();
        agent = agent.trim();
        customer_segment = customer_segment.trim();
        customer_group = customer_group.trim();
        interaction_type = interaction_type.trim();
        target_total_value = target_total_value.trim();
        target_no_of_activity = target_no_of_activity.trim();
        name = name.trim();
        target_type = target_type.trim();
        description = description.trim();
        const param = {
          month_year,
          activity_type,
          role,
          officer,
          agent,
          customer_segment,
          customer_group,
          interaction_type,
          target_total_value,
          target_no_of_activity,
          name,
          target_type,
          description
        };
        console.log({ param });

        const res = await this.$store.dispatch("targets/upload", param);
        this.tableLoading = true;
        this.doSearch();
        this.tableLoading = false;
        // console.log("response:", res);
        // set status to complete if the upload was successful
        statusRecord.status = statuses.COMPLETE;
      } catch (err) {
        // console.error("err", err);
        // statusRecord.error_list =
        //   typeof err.message == "string"
        //     ? [["error", [err.message]]]
        //     : Object.entries(err.message);
        // statusRecord.status = statuses.ERROR;
        console.error("err", err);
        statusRecord.error_list =
          typeof err.message == "string"
            ? [["error", [err.message]]]
            : Object.entries(err.message);
        statusRecord.status = statuses.ERROR;
      } finally {
        // setLoading(false);
      }
    },
    openModel() {

      this.importModal = true;
    },
    async export_roster() {

      this.tableLoading = true
      let filter_target = this.$store.state.targets.filter;
      let query_target = this.$store.state.targets.query;

      console.log('query-filter', filter_target);
      await this.$store.dispatch('targets/exportExcelData', {

        query_target,
        filter_target
      })
      this.tableLoading = false
    },
    setDefaultDateRange() {
      const currentDate = new Date();
      const currentDay = currentDate.getDay();
      const diffToSunday = currentDay === 0 ? 0 : 7 - currentDay;

      // Calculate the start date (two Sundays ago)
      const startDate = new Date(currentDate);
      startDate.setDate(currentDate.getDate() - currentDay + diffToSunday - 7);

      // Calculate the end date (next Saturday)
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 13);

      // Format dates to YYYY-MM-DD for the date input fields
      const formatDate = (date) => {
        return date.toISOString().split('T')[0];
      };

      this.filters.start_date = formatDate(startDate);
      this.filters.end_date = formatDate(endDate);
      const defaultStartTime = '10:00'; // Default start time
      const defaultEndTime = '19:00'; // Default end time
      this.filters.filter_date = formatDate(currentDate); // Set current date as the filter date
      this.filters.start_time = defaultStartTime;
      this.filters.end_time = defaultEndTime;
    },

    showModal(activityTypes) {
      this.activityTypes = activityTypes; // Set the activity types to display in the modal
      this.isModalVisible = true; // Show the modal
    },
    resetModal() {
      this.activityTypes = []; // Reset activity types when modal is closed
    },
    formatMonthYear(monthYearString) {
      const [year, month] = monthYearString.split('-'); // Split the string into year and month
      const monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ]; // Array of month names
      const monthIndex = parseInt(month) - 1; // Convert month to index (0-11)
      return `${monthNames[monthIndex]}-${year}`; // Return formatted string
    },
    cancel() {
      // Logic to close the modal
      this.showEditModal = false;
    },
    async onPageChange(newPage) {
      const totalPages = Math.ceil(this.selectedTargets.length / 1);
      if (newPage >= 1 && newPage <= totalPages) {
        this.currentPage = newPage;
      }
      console.log('this is callleddd========', selectedTargets[this.currentPage - 1][0].id);
      if (selectedTargets[this.currentPage - 1][0].id !== null && selectedTargets[this.currentPage - 1][0].id != 0) {
        this.tableLoading = true;
        await this.$store.dispatch('targets/fetchById', this.id)

        // Initialize an array to hold all filtered activity types
        let selectedActivityTypes = [];

        // Iterate through the activity types in the Vuex store
        this.$store.state.targets.targets.activity_types.forEach(activity => {
          // Filter the orderTypesArray for each activity based on activity_type_id
          let filtered_order_type = this.orderTypesArray.filter(order_type => order_type.id === activity.activity_type_id);

          // Concatenate the filtered activity types to the selectedActivityTypes array
          selectedActivityTypes = selectedActivityTypes.concat(filtered_order_type);
        });

        // Set the unique activity types in the model
        this.$set(selectedTargets[this.currentPage - 1][0], 'type', selectedActivityTypes.length ? Array.from(new Set(selectedActivityTypes)) : []);

        // Initialize an array to hold all filtered agents
        let selectedAgents = [];

        // Iterate through the agents in the Vuex store
        this.$store.state.targets.targets.agents.forEach(activity => {
          // Filter the agentArray for each agent based on agent_id
          let filtered_order_type = this.agentArray.filter(agent => agent.id === activity.agent_id);

          // Concatenate the filtered agents to the selectedAgents array
          selectedAgents = selectedAgents.concat(filtered_order_type);
        });

        // Set the unique agents in the model
        this.$set(selectedTargets[this.currentPage - 1][0], 'agent', selectedAgents.length ? Array.from(new Set(selectedAgents)) : []);

        let selectedSegments = [];

        // Iterate through the agents in the Vuex store
        this.$store.state.targets.targets.customer_segments.forEach(activity => {
          // Filter the agentArray for each agent based on agent_id
          let filtered_order_type = this.segmentArray.filter(segment => segment.id === activity.segment_id);

          // Concatenate the filtered agents to the selectedAgents array
          selectedSegments = selectedSegments.concat(filtered_order_type);
        });

        // Set the unique agents in the model
        this.$set(selectedTargets[this.currentPage - 1][0], 'customer_segment', selectedSegments.length ? Array.from(new Set(selectedSegments)) : []);

        let selectedOfficers = [];

        // Iterate through the agents in the Vuex store
        this.$store.state.targets.targets.officers.forEach(activity => {
          // Filter the agentArray for each agent based on agent_id
          let filtered_order_type = this.officerArray.filter(officer => officer.id === activity.officer_id);

          // Concatenate the filtered agents to the selectedAgents array
          selectedOfficers = selectedOfficers.concat(filtered_order_type);
        });
        console.log('officers are -------', selectedOfficers)
        // Set the unique agents in the model
        this.$set(selectedTargets[this.currentPage - 1][0], 'officer', selectedOfficers.length ? Array.from(new Set(selectedOfficers)) : []);

        let selectedRoles = [];

        // Iterate through the agents in the Vuex store
        this.$store.state.targets.targets.roles.forEach(activity => {
          // Filter the agentArray for each agent based on agent_id
          let filtered_order_type = this.roleArray.filter(role => role.id === activity.role_id);

          // Concatenate the filtered agents to the selectedAgents array
          selectedRoles = selectedRoles.concat(filtered_order_type);
        });

        // Set the unique agents in the model
        this.$set(selectedTargets[this.currentPage - 1][0], 'role', selectedRoles.length ? Array.from(new Set(selectedRoles)) : []);

        let selectedInteractionTypes = [];

        // Iterate through the agents in the Vuex store
        this.$store.state.targets.targets.interaction_types.forEach(activity => {
          // Filter the agentArray for each agent based on agent_id
          let filtered_order_type = this.interaction_typeArray.filter(type => type.id === activity.interaction_type_id);

          // Concatenate the filtered agents to the selectedAgents array
          selectedInteractionTypes = selectedInteractionTypes.concat(filtered_order_type);
        });

        // Set the unique agents in the model
        this.$set(selectedTargets[this.currentPage - 1][0], 'interaction_type', selectedInteractionTypes.length ? Array.from(new Set(selectedInteractionTypes)) : []);


        let selectedCustomerGroups = [];

        // Iterate through the agents in the Vuex store
        this.$store.state.targets.targets.customer_groups.forEach(activity => {
          // Filter the agentArray for each agent based on agent_id
          let filtered_order_type = this.customerGroupArray.filter(type => type.id === activity.customer_group_id);

          // Concatenate the filtered agents to the selectedAgents array
          selectedCustomerGroups = selectedCustomerGroups.concat(filtered_order_type);
        });

        // Set the unique agents in the model
        this.$set(selectedTargets[this.currentPage - 1][0], 'customer_group', selectedCustomerGroups.length ? Array.from(new Set(selectedCustomerGroups)) : []);
      }

      this.tableLoading = false;
    },
    addPeriod(page) {
      this.selectedTargets[page].month_year.push(''); // Adds an empty string for a new month-year
    },
    // Remove a specific entry by index for the current page
    removePeriod(page, index) {
      this.selectedTargets[page].month_year.splice(index, 1); // Removes the month-year entry from the array
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
      this.load_content();
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
      this.load_content();
    },
    async load_content() {
      console.log('load_content-----', this.selectedTargets[this.currentPage - 1][0]);
      console.log('currentPage is =====', this.currentPage);
      if (this.selectedTargets[this.currentPage - 1][0].id !== null && this.selectedTargets[this.currentPage - 1][0].id != 0) {
        this.tableLoading = true;
        // await this.$store.dispatch('targets/fetchById',this.selectedTargets[ this.currentPage - 1][0].id)
        // Function to set selected values from Vuex store based on IDs in selectedTargets
        const setSelectedValues = (sourceArray, targetKey, idArray, arrayName) => {
          let selectedItems = [];

          idArray.forEach(id => {
            const filteredItems = sourceArray.filter(item => item.id === id);
            selectedItems = selectedItems.concat(filteredItems);
          });

          this.$set(this.selectedTargets[this.currentPage - 1][0], targetKey, selectedItems.length ? Array.from(new Set(selectedItems)) : []);
        };

        // Setting selected activity types
        const activityTypeIds = this.selectedTargets[this.currentPage - 1][0].activity_types;
        setSelectedValues(this.orderTypesArray, 'type', activityTypeIds, 'activity_types');

        // Setting selected agents
        const agentIds = this.selectedTargets[this.currentPage - 1][0].agents;
        setSelectedValues(this.agentArray, 'agent', agentIds, 'agents');

        // Setting selected customer segments
        const segmentIds = this.selectedTargets[this.currentPage - 1][0].customer_segments;
        setSelectedValues(this.segmentArray, 'customer_segment', segmentIds, 'customer_segments');

        // Setting selected officers
        const officerIds = this.selectedTargets[this.currentPage - 1][0].officers;
        setSelectedValues(this.officerArray, 'officer', officerIds, 'officers');

        // Setting selected roles
        const roleIds = this.selectedTargets[this.currentPage - 1][0].roles;
        setSelectedValues(this.roleArray, 'role', roleIds, 'roles');

        // Setting selected interaction types
        const interactionTypeIds = this.selectedTargets[this.currentPage - 1][0].interaction_types;
        setSelectedValues(this.interaction_typeArray, 'interaction_type', interactionTypeIds, 'interaction_types');

        // Setting selected customer groups
        const customerGroupIds = this.selectedTargets[this.currentPage - 1][0].customer_groups;
        setSelectedValues(this.customerGroupArray, 'customer_group', customerGroupIds, 'customer_groups');

      }
      this.tableLoading = false;

    },
    onCountChecked() {
      if (this.enableCount) {
        this.enableValue = false; // Uncheck 'Value' if 'Count' is checked
      }
    },
    onValueChecked() {
      if (this.enableValue) {
        this.enableCount = false; // Uncheck 'Count' if 'Value' is checked
      }
    },
    updateActivityTypes(newValue) {
      this.selectedTargets[this.currentPage - 1][0].activity_types = newValue.map(activity => activity.id);
      console.log('activity_types', this.selectedTargets[this.currentPage - 1][0].activity_types);
    },
    updateRoles(newValue) {
      this.selectedTargets[this.currentPage - 1][0].roles = newValue.map(role => role.id);
      console.log('roles', this.selectedTargets[this.currentPage - 1][0].roles);
    },
    updateOfficers(newValue) {
      this.selectedTargets[this.currentPage - 1][0].officers = newValue.map(officer => officer.id);
      console.log('officers', this.selectedTargets[this.currentPage - 1][0].officers);
    },
    updateAgents(newValue) {
      this.selectedTargets[this.currentPage - 1][0].agents = newValue.map(agent => agent.id);
      console.log('agents', this.selectedTargets[this.currentPage - 1][0].agents);
    },
    updateCustomerSegments(newValue) {
      this.selectedTargets[this.currentPage - 1][0].customer_segments = newValue.map(segment => segment.id);
      console.log('customer_segments', this.selectedTargets[this.currentPage - 1][0].customer_segments);
    },
    updateInteractionTypes(newValue) {
      this.selectedTargets[this.currentPage - 1][0].interaction_types = newValue.map(type => type.id);
      console.log('interaction_types', this.selectedTargets[this.currentPage - 1][0].interaction_types);
    },
    updateCustomerGroups(newValue) {
      this.selectedTargets[this.currentPage - 1][0].customer_groups = newValue.map(group => group.id);
      console.log('customer_groups', this.selectedTargets[this.currentPage - 1][0].customer_groups);
    },
    async saveChanges() {
      console.log('save chhanges ', this.selectedTargets);
      this.tableLoading = true;
      await this.$store.dispatch("targets/duplicate", {
        targets: this.selectedTargets,
      });
      this.doToast(
        this.$translate("success"),
        this.$translate("target_duplicated"),
        "success"
      );
      this.doSearch()
      this.tableLoading = false;
      this.showEditModal = false;
    },
    open_extend_modal(item) {
      this.isExtendModalVisible = true;
      this.extendModel.record_to_extend = item;

    },
    handleOptionChange() {
      if (this.extendModel.isMonthSelected) {
        this.extendModel.isYearSelected = false;
      } else if (this.extendModel.isYearSelected) {
        this.extendModel.isMonthSelected = false;
        this.extendModel.numMonths = null; // clear number of months input when 'Year' is selected
      }
    },
    async extend_record(){

      this.tableLoading = true;
      await this.$store.dispatch("targets/extend", this.extendModel);
      this.doToast(
        this.$translate("success"),
        this.$translate("target_extended"),
        "success"
      );
      this.doSearch()
      this.tableLoading = false;
      this.isExtendModalVisible = false;

    }
  },



}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.role-badge-container {
  display: flex;
  flex-wrap: wrap;
  /* Allow wrapping to the next line */
  gap: 8px;
  /* Adjust space between the badges */
}

.role-badge {
  flex-basis: calc(25% - 8px);
  /* Each badge takes 25% width, minus the gap */
  text-align: center;
  /* Center align text within each badge */
  white-space: nowrap;
  /* Prevent text from wrapping inside badge */
}

.multiselect__tags-wrap {
  display: inline-block;
  height: auto;
}
</style>
